import { xhrClient } from '../../../config/axiosClient'

export type TPhoneBlockedCheck = {
    phone: string
    isBuyer: boolean
}
const postPhoneBlockedCheck = async ({
    phone,
    isBuyer = false,
}: TPhoneBlockedCheck) => {
    // replace nondigits and leading 1 - area code cannot start with 1 so this is safe
    const formattedPhone = String(phone).replace(/\D/g, '').replace(/^1/, '')

    const { data } = await xhrClient.post(`/api/check-phone-blocked-status`, {
        phone_number: formattedPhone,
        is_buyer: isBuyer,
    })

    return data
}

export default postPhoneBlockedCheck
